/**
 * 统一监控平台相关的reducer
 */
import { combineReducers } from 'redux'
import {
  SET_ERRORALARM, SET_GOODALARM, SET_WARNINGALARM, SET_LOGGOOD,
  SET_LOGERROR, SET_LOGDANGER, SET_LOGBAN, SET_FUNCTIONVALUE,
  SET_MONITORS, /*SET_CURFUNCVALNAME, SET_CURFUNCVALAVG, SET_CURFUNCVALMAX,
  SET_CURFUNCVALMIN, SET_CURFUNCVALNEW,*/ SET_FUNCVALUE, SET_CURTOWHOURNAME,
  SET_CURTOWHOURVALUE, SET_TWOHOURSREPORT, SET_MONITORTABLEDATA, SET_MONITORSSTATUS,
  SET_MONITORFILTERSTATUS, SET_GROUPID, SET_EQUIPMENTS, SET_SUBGROUPS,
  SET_STATUS, SET_GROUPINFOFILTERSTATUS, SET_MONITORTABLESELECTFIRSTFLAG, SET_SELECTEDMONITORNAME,
  SET_RESOURCESETTREE, SET_EQUIPMENTIDNTZ, SET_ALARMRULESARRAY, SET_EQUIPMENTID,
  SET_BCLICKTREENODE,SET_ONTREENODECLICK, SET_BCLICKDESVIEWMONITORTABLEROW, SET_GETMONITORDATAFILTER, SET_TREEIDS,
  SET_OLDTREE, SET_ASSETIDNTZ, SET_CREATERESOURCEVIEWID, SET_SELECTEDRESOURCE, SET_BACKUPRESOURCE, SET_CREATEMONITORVIEWID, SET_SELECTEDMONITOR,
  SET_CREATERESOURCESTABLEDATA, SET_CREATEMONITORSTABLEDATA, SET_SELECTEDNODE,SET_SELECTEDNODE_ID,SET_BACKUPTREENODE, SET_RESOURCETYPES, SET_COMMONMONITORS,
  SET_MONITORALARMCONDITIONNAMEDATA, SET_MONITORERRORALARMTEXT, SET_MONITORWARNINGALARMTEXT, SET_MONITORGOODALARMTEXT, SET_MONITORERRORCONDITIONSDATA,
  SET_MONITORSETTINGERRORCONDITIONSDATA, SET_MONITORWARNINGCONDITIONSDATA, SET_MONITORSETTINGWARNINGCONDITIONSDATA, SET_MONITORGOODCONDITIONSDATA,
  SET_MONITORSETTINGGOODCONDITIONSDATA, SET_DELETEMONITORALARMCONDITIONSDATA, SET_EQUIPMENTSERVERADDRESS, SET_EQUIPMENTMODEL, SET_NAVIGATEFROMCREATEMONITORVIEWFLAG,
  SET_MONITORDISKS, SET_MONITORHASDISKS, SET_MONITORDISKIONAMES, SET_MONITORHASDISKIONAMES, SET_NETWORKS, SET_HASNETWORKS, SET_SELECTEDNETWORK, SET_SELECTEDMONITORDISK, SET_SELECTEDMONITORDISKIONAME,
  SET_MONITORNETWORKS, SET_MONITORHASNETWORKS, SET_SELECTEDMONITORNETWORK, SET_MONITORDISKINODES, SET_MONITORHASDISKINODES, SET_SELECTEDMONITORDISKINODES, SET_MONITORPROCESSES, SET_MONITORHASPROCESSES,
  SET_SELECTEDMONITORPROCESS, SET_MONITORSERVICES, SET_MONITORHASSERVICES, SET_SELECTEDMONITORSERVICE, SET_MONITORNTEVENTLOGS, SET_SELECTEDMONITORNTEVENTLOG, SET_MONITORSCRIPTS, SET_SELECTEDMONITORSCRIPT,
  SET_MONITORS_PROPERTY_DATA, SET_MONITORS_PROPERTY_EDIT, SET_MONITORS_MYSQL_COUNTERDATA, SET_MONITORS_MYSQL_PROPERTYCOUNTERDATA,
  SET_GETMONITORSPROPERTYDATADONEFLAG, SET_GETALARMCONDITIONDATADONEFLAG, SET_GETMYSQLMONITORCOUNTERDATADONEFLAG, SET_MONITORS_MYSQL_CURRENTCOUNTER,
  SET_MONITORS_ORACLE_COUNTERDATA, SET_MONITORS_ORACLE_PROPERTYCOUNTERDATA, SET_MONITORS_ORACLE_CURRENTCOUNTER,
  SET_MONITORSCRIPTS_ENTRYALIAS, SET_GETMONITORSENTRYALIASDATADONEFLAG, SET_GETMONITORSSNMPMIBFILEDATADONEFLAG, SET_MONITORSNMPMIBFILE, SET_MONITORSNMPMIBCOUNTER,
  SET_SELECTEDMONITORSNMPMIBCOUNTER, SET_SELECTEDMONITORMONGOQUERY, SET_MONITORSTORAGEDISKS, SET_SELECTEDMONITORSTORAGEDISK,
  SET_MONITORSQLSERVERCOUNTERS, SET_MONITORS_SQLSERVER_PROPERTYCOUNTERDATA, SET_SELECTEDMONITORSQLSERVERCOUNTER, SET_GETSQLSERVERMONITORCOUNTERDATADONEFLAG, SET_MONITORIPMISENSORCOUNTERS, SET_SELECTEDMONITORIPMISENSORCOUNTER,
  SET_MONITORSTORAGEPROCESSORS, SET_SELECTEDMONITORSTORAGEPROCESSOR, SET_MONITORFIBRECHANNELSTATUSNODES, SET_SELECTEDMONITORFIBRECHANNELSTATUSNODES, SET_MONITORSTORAGEVOLUMEFILES, SET_SELECTEDMONITORSTORAGEVOLUMEFILE,
  SET_MONITORROOMENVIRONMENTOBJECTS, SET_SELECTEDMONITORROOMENVIRONMENTOBJECT, SET_MONITORWEBLOGICEXECUTEQUEUES, SET_SELECTEDMONITORWEBLOGICEXECUTEQUEUE,
  SET_MONITORWEBLOGICWEBAPPS, SET_SELECTEDMONITORWEBLOGICWEBAPP, SET_MONITORWEBLOGICCONNPOOLS, SET_SELECTEDMONITORWEBLOGICCONNPOOL, SET_MONITORVMWAREHOSTNETWORKS, SET_SELECTEDMONITORVMWAREHOSTNETWORK,
  SET_MONITORVMWAREPERFORMANCESS, SET_SELECTEDMONITORVMWAREPERFORMANCES, SET_MONITORWEBLOGICCLUSTERS, SET_SELECTEDMONITORWEBLOGICCLUSTER, SET_MONITORWEBLOGICSERVERS, SET_SELECTEDMONITORWEBLOGICSERVER,
  SET_MONITORWEBLOGICHEAPS, SET_SELECTEDMONITORWEBLOGICHEAP, SET_MONITORAGENTDISKSPACEDISKNAMES, SET_SELECTEDMONITORAGENTDISKSPACEDISKNAME, SET_MONITORAGENTPROCESSS, SET_SELECTEDMONITORAGENTPROCESS,
  SET_MONITORAGENTSERVICES, SET_SELECTEDMONITORAGENTSERVICE, SET_MONITORAGENTNETIFS, SET_SELECTEDMONITORAGENTNETIF, SET_MONITORAGENTDISKIONAMES, SET_SELECTEDMONITORAGENTDISKIONAME,
  SET_MONITORAGENTDISKINODESNAMES, SET_SELECTEDMONITORAGENTDISKINODESNAME, SET_MONITORAGENTSCRIPTS, SET_SELECTEDMONITORAGENTSCRIPT, SET_BEADDMONITORSNODE,
  SET_MONITORORACLETABLESPACE, SET_SELECTEDMONITORORACLETABLESPACE, SET_RESOURCES_PROPERTY_DATA, SET_GETRESOURCESPROPERTYDATADONEFLAG, SET_RESOURCES_PROPERTY_EDIT,
  SET_EQUIPMENT_MONITOR_PAGE, SET_DEPEND, SET_ALERTDEPEND, SET_RESOURCESALARMCONFIG, SET_RESOURCESSELECTEDALARMCONFIG, SET_RESOURCE_EQUIPMENTMODEL, SET_RESOURCEMODAL,SET_TEST_PROPERTY_DATA,SET_EQUIPMENT_ACCESSORYINFOS,
  SAVE_CREATEMONITORS, SAVE_RESOURCEDATA, SET_OPERATEMONITOR, SET_EQUIPMENTGROUPID, SET_EQUIPMENTWINDOWSTORE, SET_REFRESH_RESOURCE_MONITORS, SET_LOADING_MONITOR_LIST, SET_SELECTED_CLICK_NODE, SET_RESOURCE_VIEW_ACTIVE_TAB, SET_EQUIPMENTINFOMAINTENANCEDATA,
  SET_MONITOR_STATUS_REPORT_DATA, SET_BATCH_MONITOR_STATUS_REPORT_DATA, SET_SAFE_GROUP_LIST, SET_TASK_SCHEDULER_LIST, SET_NETWORK_NODE_TYPE, SET_EQUIPMENT_NODE_TYPE, SET_NETWORK_RELATIONS, SET_SELECTEDLEVEL, SET_MONITORDETAILVIEWACTIVETAB, SET_DRAGGEDNODE, SET_SELECTED_MONITOR_FROM_3D,
  SET_VMWARE_NAMES, SET_HAS_VMWARE_NAMES, SET_SELECTED_VMWARE_NAMES, SET_MONITORDETAILVIEWTIMERANGE,
} from '../actions/equipment_action'

function monitorDetailViewActiveTab(state = '1', action){
  switch (action.type) {
    case SET_MONITORDETAILVIEWACTIVETAB:
      return action.monitorDetailViewActiveTab;
    default:
      return state;
  }
}

function monitorDetailViewTimeRange(state = { logsRange: "2H", queryRangeTime: { startTime: null, endTime: null } }, action){
  switch (action.type) {
    case SET_MONITORDETAILVIEWTIMERANGE:
      return action.monitorDetailViewTimeRange;
    default:
      return state;
  }
}

function equipmentInfoMaintenanceData(state = [], action){
  switch (action.type) {
    case SET_EQUIPMENTINFOMAINTENANCEDATA:
      return action.equipmentInfoMaintenanceData;
    default:
      return state;
  }
}

//设置被添加监测器的资源节点
function beAddMonitorsNode(state = null, action) {
  switch (action.type) {
    case SET_BEADDMONITORSNODE:
      return action.beAddMonitorsNode;
    default:
      return state;
  }
}

//设置跳转路由
function equipmentMonitorUrl(state = "", action) {
    switch (action.type) {
        case SET_EQUIPMENT_MONITOR_PAGE:
            return action.equipmentMonitorUrl
        default:
            return state
    }
};

function equipmentWindowStore(state = {}, action) {
  switch (action.type) {
    case SET_EQUIPMENTWINDOWSTORE:
      return action.equipmentWindowStore;
    default:
      return state;
  }
}

function errorAlarm(state = "", action) {
    switch (action.type) {
        case SET_ERRORALARM:
            return action.errorAlarm
        default:
            return state
    }
}

function goodAlarm(state = "", action) {
    switch (action.type) {
        case SET_GOODALARM:
            return action.goodAlarm
        default:
            return state
    }
}

function warningAlarm(state = "", action) {
    switch (action.type) {
        case SET_WARNINGALARM:
            return action.warningAlarm
        default:
            return state
    }
}

function logGood(state = "0", action) {
    switch (action.type) {
        case SET_LOGGOOD:
            return action.logGood
        default:
            return state
    }
}

function logError(state = "0", action) {
    switch (action.type) {
        case SET_LOGERROR:
            return action.logError
        default:
            return state
    }
}

function logDanger(state = "0", action) {
    switch (action.type) {
        case SET_LOGDANGER:
            return action.logDanger
        default:
            return state
    }
}

function logBan(state = "0", action) {
    switch (action.type) {
        case SET_LOGBAN:
            return action.logBan
        default:
            return state
    }
}

function functionValue(state = "", action) {
    switch (action.type) {
        case SET_FUNCTIONVALUE:
            return action.functionValue
        default:
            return state
    }
}

function monitors(state = [], action) {
    switch (action.type) {
        case SET_MONITORS:
            return action.monitors
        default:
            return state
    }
}

// function curFuncValName(state = "", action) {
//     switch (action.type) {
//         case SET_CURFUNCVALNAME:
//             return action.curFuncValName
//         default:
//             return state
//     }
// }
//
// function curFuncValAvg(state = 0, action) {
//     switch (action.type) {
//         case SET_CURFUNCVALAVG:
//             return action.curFuncValAvg
//         default:
//             return state
//     }
// }
//
// function curFuncValMax(state = 0, action) {
//     switch (action.type) {
//         case SET_CURFUNCVALMAX:
//             return action.curFuncValMax
//         default:
//             return state
//     }
// }
//
// function curFuncValMin(state = 0, action) {
//     switch (action.type) {
//         case SET_CURFUNCVALMIN:
//             return action.curFuncValMin
//         default:
//             return state
//     }
// }
//
// function curFuncValNew(state = 0, action) {
//     switch (action.type) {
//         case SET_CURFUNCVALNEW:
//             return action.curFuncValNew
//         default:
//             return state
//     }
// }

function funcValue(state = [], action) {
    switch (action.type) {
        case SET_FUNCVALUE:
            if(action.funcValue == null || action.funcValue.length == 0) {
                return [];
            }
            else {
                return action.funcValue
            }
        default:
            return state
    }
}

function curTowHourName(state = "", action) {
    switch (action.type) {
        case SET_CURTOWHOURNAME:
            return action.curTowHourName
        default:
            return state
    }
}

function curTowHourValue(state = [], action) {
    switch (action.type) {
        case SET_CURTOWHOURVALUE:
            return action.curTowHourValue
        default:
            return state
    }
}

function twoHoursReport(state = [], action) {
    switch (action.type) {
        case SET_TWOHOURSREPORT:
            if(action.twoHoursReport == null || action.twoHoursReport.length == 0) {
                return [];
            }
            else {
                return action.twoHoursReport
            }
        default:
            return state
    }
}

function monitorTableData(state = [], action) {
    switch (action.type) {
        case SET_MONITORTABLEDATA:
            return action.monitorTableData
        default:
            return state
    }
}

function monitorsStatus(state = [], action) {
    switch (action.type) {
        case SET_MONITORSSTATUS:
            return action.monitorsStatus
        default:
            return state
    }
}

function monitorFilterStatus(state = "all", action) {
    switch (action.type) {
        case SET_MONITORFILTERSTATUS:
            return action.monitorFilterStatus
        default:
            return state
    }
}

function groupId(state = "", action) {
    switch (action.type) {
        case SET_GROUPID:
            return action.groupId
        default:
            return state
    }
}

function equipments(state = [], action) {
    switch (action.type) {
        case SET_EQUIPMENTS:
            return action.equipments
        default:
            return state
    }
}

function subGroups(state = [], action) {
    switch (action.type) {
        case SET_SUBGROUPS:
            return action.subGroups
        default:
            return state
    }
}

function status(state = [], action) {
    switch (action.type) {
        case SET_STATUS:
            return action.status
        default:
            return state
    }
}

function groupInfoFilterStatus(state = "all", action) {
    switch (action.type) {
        case SET_GROUPINFOFILTERSTATUS:
            return action.groupInfoFilterStatus
        default:
            return state
    }
}

function monitorTableSelectFirstFlag(state = false, action) {
    switch (action.type) {
        case SET_MONITORTABLESELECTFIRSTFLAG:
            return action.monitorTableSelectFirstFlag
        default:
            return state
    }
}

function selectedMonitorName(state = "", action) {
    switch (action.type) {
        case SET_SELECTEDMONITORNAME:
            return action.selectedMonitorName
        default:
            return state
    }
}

function resourceSetTree(state = [], action) {
    switch (action.type) {
        case SET_RESOURCESETTREE:
            return action.resourceSetTree
        default:
            return state
    }
}

function equipmentIdNtz(state = "", action) {
    switch (action.type) {
        case SET_EQUIPMENTIDNTZ:
            return action.equipmentIdNtz
        default:
            return state
    }
}

function alarmRulesArray(state = [], action) {
    switch (action.type) {
        case SET_ALARMRULESARRAY:
            return action.alarmRulesArray
        default:
            return state
    }
}

function equipmentId(state = "", action) {
    switch (action.type) {
        case SET_EQUIPMENTID:
            return action.equipmentId
        default:
            return state
    }
}

function bClickTreeNode(state = true, action) {
    switch (action.type) {
        case SET_BCLICKTREENODE:
            return action.bClickTreeNode
        default:
            return state
    }
}
//是否允许树节点数据被更新标志
function onTreeNodeClick(state = false, action) {
    switch (action.type) {
        case SET_ONTREENODECLICK:
            return action.onTreeNodeClick
        default:
            return state
    }
}

function bClickDesViewMonitorTableRow(state = false, action) {
    switch (action.type) {
        case SET_BCLICKDESVIEWMONITORTABLEROW:
            return action.bClickDesViewMonitorTableRow
        default:
            return state
    }
}

function getMonitorDataFilter(state = [], action) {
    switch (action.type) {
        case SET_GETMONITORDATAFILTER:
            return action.getMonitorDataFilter
        default:
            return state
    }
}

function treeIds(state = [], action) {
    switch (action.type) {
        case SET_TREEIDS:
            return action.treeIds
        default:
            return state
    }
}

function oldTree(state = [], action) {
    switch (action.type) {
        case SET_OLDTREE:
            return action.oldTree
        default:
            return state
    }
}

function assetIdNtz(state = "", action) {
    switch (action.type) {
        case SET_ASSETIDNTZ:
            return action.assetIdNtz
        default:
            return state
    }
}

function createResourceViewId(state = 0, action) {
    switch (action.type) {
        case SET_CREATERESOURCEVIEWID:
            return action.createResourceViewId
        default:
            return state
    }
}
function selectedResource(state = null, action) {
    switch (action.type) {
        case SET_SELECTEDRESOURCE:
            // Redux 要求 reducer 不能返回 undefined：undefined 入参归为 null（"无选中"）
            return action.selectedResource === undefined ? null : action.selectedResource
        default:
            return state
    }
}

function backupResource(state = null, action) {
    switch (action.type) {
        case SET_BACKUPRESOURCE:
            return action.backupResource
        default:
            return state
    }
}

function createMonitorViewId(state = 0, action) {
    switch (action.type) {
        case SET_CREATEMONITORVIEWID:
            return action.createMonitorViewId
        default:
            return state
    }
}
function selectedMonitor(state = null, action) {
    switch (action.type) {
        case SET_SELECTEDMONITOR:
            return action.selectedMonitor
        default:
            return state
    }
}

function createResourcesTableData(state = [], action) {
    switch (action.type) {
        case SET_CREATERESOURCESTABLEDATA:
            return action.createResourcesTableData
        default:
            return state
    }
}

function createMonitorsTableData(state = [], action) {
    switch (action.type) {
        case SET_CREATEMONITORSTABLEDATA:
            return action.createMonitorsTableData
        default:
            return state
    }
}

function selectedNode(state = null, action) {
    switch (action.type) {
        case SET_SELECTEDNODE:
            return action.selectedNode
        default:
            return state
    }
}
function selectedNodeId(state='', action){
  switch(action.type){
    case SET_SELECTEDNODE_ID:
      return action.selectedNodeId;
    default:
      return state;
  }
}

function backupTreeNode(state = null, action) {
    switch (action.type) {
        case SET_BACKUPTREENODE:
            return action.backupTreeNode
        default:
            return state
    }
}

function resourceTypes(state = [], action) {
    switch (action.type) {
        case SET_RESOURCETYPES:
            return action.resourceTypes
        default:
            return state
    }
}

function commonMonitors(state = [], action) {
    switch (action.type) {
        case SET_COMMONMONITORS:
            return action.commonMonitors
        default:
            return state
    }
}

function monitorAlarmConditionNameData(state = [], action) {
    switch (action.type) {
        case SET_MONITORALARMCONDITIONNAMEDATA:
            return action.monitorAlarmConditionNameData
        default:
            return state
    }
}

function monitorErrorAlarmText(state = "", action) {
    switch (action.type) {
        case SET_MONITORERRORALARMTEXT:
            return action.monitorErrorAlarmText
        default:
            return state
    }
}

function monitorWarningAlarmText(state = "", action) {
    switch (action.type) {
        case SET_MONITORWARNINGALARMTEXT:
            return action.monitorWarningAlarmText
        default:
            return state
    }
}

function monitorGoodAlarmText(state = "", action) {
    switch (action.type) {
        case SET_MONITORGOODALARMTEXT:
            return action.monitorGoodAlarmText
        default:
            return state
    }
}

function monitorErrorConditionsData(state = [], action) {
    switch (action.type) {
        case SET_MONITORERRORCONDITIONSDATA:
            return action.monitorErrorConditionsData
        default:
            return state
    }
}

function monitorSettingErrorConditionsData(state = [], action) {
    switch (action.type) {
        case SET_MONITORSETTINGERRORCONDITIONSDATA:
            return action.monitorSettingErrorConditionsData
        default:
            return state
    }
}

function monitorWarningConditionsData(state = [], action) {
    switch (action.type) {
        case SET_MONITORWARNINGCONDITIONSDATA:
            return action.monitorWarningConditionsData
        default:
            return state
    }
}

function monitorSettingWarningConditionsData(state = [], action) {
    switch (action.type) {
        case SET_MONITORSETTINGWARNINGCONDITIONSDATA:
            return action.monitorSettingWarningConditionsData
        default:
            return state
    }
}

function monitorGoodConditionsData(state = [], action) {
    switch (action.type) {
        case SET_MONITORGOODCONDITIONSDATA:
            return action.monitorGoodConditionsData
        default:
            return state
    }
}

function monitorSettingGoodConditionsData(state = [], action) {
    switch (action.type) {
        case SET_MONITORSETTINGGOODCONDITIONSDATA:
            return action.monitorSettingGoodConditionsData
        default:
            return state
    }
}

function deleteMonitorAlarmConditionsData(state = [], action) {
    switch (action.type) {
        case SET_DELETEMONITORALARMCONDITIONSDATA:
            return action.deleteMonitorAlarmConditionsData
        default:
            return state
    }
}

function equipmentServerAddress(state = "", action) {
    switch (action.type) {
        case SET_EQUIPMENTSERVERADDRESS:
            return action.equipmentServerAddress
        default:
            return state
    }
}

function equipmentModel(state = "", action) {
    switch (action.type) {
        case SET_EQUIPMENTMODEL:
            return action.equipmentModel
        default:
            return state
    }
}

function navigateFromCreateMonitorViewFlag(state = false, action) {
    switch (action.type) {
        case SET_NAVIGATEFROMCREATEMONITORVIEWFLAG:
            return action.navigateFromCreateMonitorViewFlag
        default:
            return state
    }
}

function monitorDisks(state = [], action) {
    switch (action.type) {
        case SET_MONITORDISKS:
            return action.monitorDisks
        default:
            return state
    }
}

function monitorHasDisks(state = [], action) {
    switch (action.type) {
        case SET_MONITORHASDISKS:
            return action.monitorHasDisks
        default:
            return state
    }
}

function selectedMonitorDisk(state = null, action) {
    switch (action.type) {
        case SET_SELECTEDMONITORDISK:
            return action.selectedMonitorDisk
        default:
            return state
    }
}

function monitorDiskInodes(state = [], action) {
    switch (action.type) {
        case SET_MONITORDISKINODES:
            return action.monitorDiskInodes
        default:
            return state
    }
}

function monitorHasDiskInodes(state = [], action) {
    switch (action.type) {
        case SET_MONITORHASDISKINODES:
            return action.monitorHasDiskInodes
        default:
            return state
    }
}

function selectedMonitorDiskInodes(state = null, action) {
    switch (action.type) {
        case SET_SELECTEDMONITORDISKINODES:
            return action.selectedMonitorDiskInodes
        default:
            return state
    }
}

function monitorDiskIONames(state = [], action) {
    switch (action.type) {
        case SET_MONITORDISKIONAMES:
            return action.monitorDiskIONames
        default:
            return state
    }
}

function monitorHasDiskIONames(state = [], action) {
    switch (action.type) {
        case SET_MONITORHASDISKIONAMES:
            return action.monitorHasDiskIONames
        default:
            return state
    }
}

function selectedMonitorDiskIOName(state = [], action) {
    switch (action.type) {
        case SET_SELECTEDMONITORDISKIONAME:
            return action.selectedMonitorDiskIOName
        default:
            return state
    }
}

function networks(state = [], action) {
    switch (action.type) {
        case SET_NETWORKS:
            return action.networks
        default:
            return state
    }
}

function hasNetworks(state = [], action) {
    switch (action.type) {
        case SET_HASNETWORKS:
            return action.hasNetworks
        default:
            return state
    }
}

function selectedNetwork(state = [], action) {
    switch (action.type) {
    case SET_SELECTEDNETWORK:
            return action.selectedNetwork
        default:
            return state
    }
}

function monitorNetworks(state = [], action) {
    switch (action.type) {
        case SET_MONITORNETWORKS:
            return action.monitorNetworks
        default:
            return state
    }
}

function monitorHasNetworks(state = [], action) {
    switch (action.type) {
        case SET_MONITORHASNETWORKS:
            return action.monitorHasNetworks
        default:
            return state
    }
}

function selectedMonitorNetwork(state = null, action) {
    switch (action.type) {
        case SET_SELECTEDMONITORNETWORK:
            return action.selectedMonitorNetwork
        default:
            return state
    }
}

function monitorProcesses(state = [], action) {
    switch (action.type) {
        case SET_MONITORPROCESSES:
            return action.monitorProcesses
        default:
            return state
    }
}

function monitorHasProcesses(state = [], action) {
    switch (action.type) {
        case SET_MONITORHASPROCESSES:
            return action.monitorHasProcesses
        default:
            return state
    }
}

function selectedMonitorProcess(state = null, action) {
    switch (action.type) {
        case SET_SELECTEDMONITORPROCESS:
            return action.selectedMonitorProcess
        default:
            return state
    }
}

function monitorServices(state = [], action) {
    switch (action.type) {
        case SET_MONITORSERVICES:
            return action.monitorServices
        default:
            return state
    }
}

function monitorHasServices(state = [], action) {
    switch (action.type) {
        case SET_MONITORHASSERVICES:
            return action.monitorHasServices
        default:
            return state
    }
}

function selectedMonitorService(state = [], action) {
    switch (action.type) {
        case SET_SELECTEDMONITORSERVICE:
            return action.selectedMonitorService
        default:
            return state
    }
}

function monitorNTEventLogs(state = [], action) {
    switch (action.type) {
        case SET_MONITORNTEVENTLOGS:
            return action.monitorNTEventLogs
        default:
            return state
    }
}

function selectedMonitorNTEventLog(state = null, action) {
    switch (action.type) {
        case SET_SELECTEDMONITORNTEVENTLOG:
            return action.selectedMonitorNTEventLog
        default:
            return state
    }
}

function monitorScripts(state = [], action) {
    switch (action.type) {
        case SET_MONITORSCRIPTS:
            return action.monitorScripts
        default:
            return state
    }
}

function selectedMonitorScript(state = null, action) {
    switch (action.type) {
        case SET_SELECTEDMONITORSCRIPT:
            return action.selectedMonitorScript
        default:
            return state
    }
}

function VMwareNames(state = [], action) {
    switch (action.type) {
        case SET_VMWARE_NAMES:
            return action.VMwareNames
        default:
            return state
    }
}

function hasVMwareNames(state = [], action) {
    switch (action.type) {
        case SET_HAS_VMWARE_NAMES:
            return action.hasVMwareNames
        default:
            return state
    }
}

function selectedVMwareNames(state = null, action) {
    switch (action.type) {
        case SET_SELECTED_VMWARE_NAMES:
            return action.selectedVMwareNames
        default:
            return state
    }
}

function getMonitorsPropertyDataDoneFlag(state = false, action) {
    switch (action.type) {
        case SET_GETMONITORSPROPERTYDATADONEFLAG:
            return action.getMonitorsPropertyDataDoneFlag
        default:
            return state
    }
}

function getAlarmConditionDataDoneFlag(state = false, action) {
    switch (action.type) {
        case SET_GETALARMCONDITIONDATADONEFLAG:
            return action.getAlarmConditionDataDoneFlag
        default:
            return state
    }
}

function getMySqlMonitorCounterDataDoneFlag(state = false, action) {
    switch (action.type) {
        case SET_GETMYSQLMONITORCOUNTERDATADONEFLAG:
            return action.getMySqlMonitorCounterDataDoneFlag
        default:
            return state
    }
}

function getSQLServerMonitorCounterDataDoneFlag(state = false, action) {
    switch (action.type) {
        case SET_GETSQLSERVERMONITORCOUNTERDATADONEFLAG:
            return action.getSQLServerMonitorCounterDataDoneFlag
        default:
            return state
    }
}

function isShowTree(state = true ,action){
  switch (action.type) {
      case "ISSHOWTREE":
        return action.data;
      default:
        return state
  }
}

function getOldTree(state = [], action) {
    switch (action.type) {
        case "GETOLDRESOURCETREENODE":
            return action.checkedNodes
        default:
            return state
    }
};

//监测器属性数据
function monitorsPropertyData(state = null, action) {
    switch (action.type) {
        case "SET_MONITORS_PROPERTY_DATA":
            return action.monitorsPropertyData
        default:
            return state
    }
};


//设置监测器属性编辑状态，true 是编辑监测器 false 是增加监测器
function monitorsPropertyEdit(state = false, action) {
    switch (action.type) {
        case "SET_MONITORS_PROPERTY_EDIT":
            return action.monitorsPropertyEdit
        default:
            return state
    }
};

//MySQL监测器:计数器 所有可选择项数据
function mySqlCounterData(state = [], action) {
    switch (action.type) {
        case "SET_MONITORS_MYSQL_COUNTERDATA":
            return action.mySqlCounterData
        default:
            return state
    }
};

//MySQL监测器:计数器 属性数据
function mySqlMonitorsPropertyCounterData(state = [], action) {
    switch (action.type) {
        case "SET_MONITORS_MYSQL_PROPERTYCOUNTERDATA":
            return action.mySqlMonitorsPropertyCounterData
        default:
            return state
    }
};

//MySQL监测器:计数器 当前选择项的数据
function mySqlCurrentCounterData(state = [], action) {
    switch (action.type) {
        case "SET_MONITORS_MYSQL_CURRENTCOUNTER":
            return action.mySqlCurrentCounterData
        default:
            return state
    }
};
//SQL监测器:计数器 所有可选择项数据
function monitorSQLServerCounters(state = [], action) {
    switch (action.type) {
        case SET_MONITORSQLSERVERCOUNTERS:
            return action.monitorSQLServerCounters
        default:
            return state
    }
};
//SQL监测器:计数器 属性数据
function sqlServerMonitorsPropertyCounterData(state = [], action) {
    switch (action.type) {
        case "SET_MONITORS_SQLSERVER_PROPERTYCOUNTERDATA":
            return action.sqlServerMonitorsPropertyCounterData
        default:
            return state
    }
};
//SQL监测器:计数器 当前选择项的数据
function selectedMonitorSQLServerCounter(state = null, action) {
    switch (action.type) {
        case SET_SELECTEDMONITORSQLSERVERCOUNTER:
            return action.selectedMonitorSQLServerCounter
        default:
            return state
    }
};

//Oracle监测器:计数器 所有可选择项数据
function OracleCounterData(state = [], action) {
    switch (action.type) {
        case "SET_MONITORS_ORACLE_COUNTERDATA":
            return action.OracleCounterData
        default:
            return state
    }
};

//Oracle监测器:计数器 属性数据
function OracleMonitorsPropertyCounterData(state = [], action) {
    switch (action.type) {
        case "SET_MONITORS_ORACLE_PROPERTYCOUNTERDATA":
            return action.OracleMonitorsPropertyCounterData
        default:
            return state
    }
};

//Oracle监测器:计数器 当前选择项的数据
function OracleCurrentCounterData(state = [], action) {
    switch (action.type) {
        case "SET_MONITORS_ORACLE_CURRENTCOUNTER":
            return action.OracleCurrentCounterData
        default:
            return state
    }
};

function monitorScriptsEntryAlias(state = [], action) {
    switch (action.type) {
        case "SET_MONITORSCRIPTS_ENTRYALIAS":
            return action.monitorScriptsEntryAlias
        default:
            return state
    }
};

function getMonitorsEntryAliasDataDoneFlag(state = false, action) {
    switch (action.type) {
        case "SET_GETMONITORSENTRYALIASDATADONEFLAG":
            return action.getMonitorsEntryAliasDataDoneFlag
        default:
            return state
    }
};

function getMonitorsSnmpMIBFileDataDoneFlag(state = false, action) {
    switch (action.type) {
        case "SET_GETMONITORSSNMPMIBFILEDATADONEFLAG":
            return action.getMonitorsSnmpMIBFileDataDoneFlag
        default:
            return state
    }
};

function monitorSnmpMIBFile(state = [], action) {
    switch (action.type) {
        case "SET_MONITORSNMPMIBFILE":
            return action.monitorSnmpMIBFile
        default:
            return state
    }
};

function monitorSnmpMIBCounter(state = {}, action) {
    switch (action.type) {
        case "SET_MONITORSNMPMIBCOUNTER":
            return action.monitorSnmpMIBCounter
        default:
            return state
    }
};

function selectedMonitorSnmpMIBCounter(state = null, action) {
    switch (action.type) {
        case "SET_SELECTEDMONITORSNMPMIBCOUNTER":
            return action.selectedMonitorSnmpMIBCounter
        default:
            return state
    }
};

function selectedMonitorMongoQuery(state = null, action) {
    switch (action.type) {
        case SET_SELECTEDMONITORMONGOQUERY:
            return action.selectedMonitorMongoQuery
        default:
            return state
    }
};

function monitorStorageDisks(state = [], action) {
    switch (action.type) {
        case SET_MONITORSTORAGEDISKS:
            return action.monitorStorageDisks
        default:
            return state
    }
};

function selectedMonitorStorageDisk(state = [], action) {
    switch (action.type) {
        case SET_SELECTEDMONITORSTORAGEDISK:
            return action.selectedMonitorStorageDisk
        default:
            return state
    }
};

function monitorIPMISensorCounters(state = [], action) {
    switch (action.type) {
        case SET_MONITORIPMISENSORCOUNTERS:
            return action.monitorIPMISensorCounters
        default:
            return state
    }
};

function selectedMonitorIPMISensorCounter(state = [], action) {
    switch (action.type) {
        case SET_SELECTEDMONITORIPMISENSORCOUNTER:
            return action.selectedMonitorIPMISensorCounter
        default:
            return state
    }
};

function monitorStorageProcessors(state = [], action) {
    switch (action.type) {
        case SET_MONITORSTORAGEPROCESSORS:
            return action.monitorStorageProcessors
        default:
            return state
    }
};

function selectedMonitorStorageProcessor(state = [], action) {
    switch (action.type) {
        case SET_SELECTEDMONITORSTORAGEPROCESSOR:
            return action.selectedMonitorStorageProcessor
        default:
            return state
    }
};

function monitorFibreChannelStatusNodes(state = [], action) {
    switch (action.type) {
        case SET_MONITORFIBRECHANNELSTATUSNODES:
            return action.monitorFibreChannelStatusNodes
        default:
            return state
    }
};

function selectedMonitorFibreChannelStatusNode(state = [], action) {
    switch (action.type) {
        case SET_SELECTEDMONITORFIBRECHANNELSTATUSNODES:
            return action.selectedMonitorFibreChannelStatusNode
        default:
            return state
    }
};

function monitorStorageVolumeFiles(state = [], action) {
    switch (action.type) {
        case SET_MONITORSTORAGEVOLUMEFILES:
            return action.monitorStorageVolumeFiles
        default:
            return state
    }
};

function selectedMonitorStorageVolumeFile(state = [], action) {
    switch (action.type) {
        case SET_SELECTEDMONITORSTORAGEVOLUMEFILE:
            return action.selectedMonitorStorageVolumeFile
        default:
            return state
    }
};

function monitorRoomEnvironmentObjects(state = [], action) {
    switch (action.type) {
        case SET_MONITORROOMENVIRONMENTOBJECTS:
            return action.monitorRoomEnvironmentObjects
        default:
            return state
    }
};

function selectedMonitorRoomEnvironmentObject(state = [], action) {
    switch (action.type) {
        case SET_SELECTEDMONITORROOMENVIRONMENTOBJECT:
            return action.selectedMonitorRoomEnvironmentObject
        default:
            return state
    }
};

function monitorWeblogicExecuteQueues(state = [], action) {
    switch (action.type) {
        case SET_MONITORWEBLOGICEXECUTEQUEUES:
            return action.monitorWeblogicExecuteQueues
        default:
            return state
    }
};

function selectedMonitorWeblogicExecuteQueue(state = null, action) {
    switch (action.type) {
        case SET_SELECTEDMONITORWEBLOGICEXECUTEQUEUE:
            return action.selectedMonitorWeblogicExecuteQueue
        default:
            return state
    }
};

function monitorWeblogicWebApps(state = [], action) {
    switch (action.type) {
    case SET_MONITORWEBLOGICWEBAPPS:
            return action.monitorWeblogicWebApps
        default:
            return state
    }
};

function selectedMonitorWeblogicWebApp(state = null, action) {
    switch (action.type) {
    case SET_SELECTEDMONITORWEBLOGICWEBAPP:
            return action.selectedMonitorWeblogicWebApp
        default:
            return state
    }
};

function monitorWeblogicConnPools(state = [], action) {
    switch (action.type) {
        case SET_MONITORWEBLOGICCONNPOOLS:
            return action.monitorWeblogicConnPools
        default:
            return state
    }
};

function selectedMonitorWeblogicConnPool(state = null, action) {
    switch (action.type) {
        case SET_SELECTEDMONITORWEBLOGICCONNPOOL:
            return action.selectedMonitorWeblogicConnPool
        default:
            return state
    }
};

function monitorVMwareHostNetworks(state = [], action) {
    switch (action.type) {
        case SET_MONITORVMWAREHOSTNETWORKS:
            return action.monitorVMwareHostNetworks
        default:
            return state
    }
};

function selectedMonitorVMwareHostNetwork(state = [], action) {
    switch (action.type) {
        case SET_SELECTEDMONITORVMWAREHOSTNETWORK:
            return action.selectedMonitorVMwareHostNetwork
        default:
            return state
    }
};

function monitorVMwarePerformances(state = null, action) {
    switch (action.type) {
        case SET_MONITORVMWAREPERFORMANCESS:
            return action.monitorVMwarePerformances
        default:
            return state
    }
};

function selectedMonitorVMwarePerformance(state = [], action) {
    switch (action.type) {
        case SET_SELECTEDMONITORVMWAREPERFORMANCES:
            return action.selectedMonitorVMwarePerformance
        default:
            return state
    }
};

function monitorWeblogicClusters(state = [], action) {
    switch (action.type) {
        case SET_MONITORWEBLOGICCLUSTERS:
            return action.monitorWeblogicClusters
        default:
            return state
    }
};

function selectedMonitorWeblogicCluster(state = null, action) {
    switch (action.type) {
        case SET_SELECTEDMONITORWEBLOGICCLUSTER:
            return action.selectedMonitorWeblogicCluster
        default:
            return state
    }
};

function monitorWeblogicServers(state = [], action) {
    switch (action.type) {
        case SET_MONITORWEBLOGICSERVERS:
            return action.monitorWeblogicServers
        default:
            return state
    }
};

function selectedMonitorWeblogicServer(state = null, action) {
    switch (action.type) {
        case SET_SELECTEDMONITORWEBLOGICSERVER:
            return action.selectedMonitorWeblogicServer
        default:
            return state
    }
};

function monitorWeblogicHeaps(state = [], action) {
    switch (action.type) {
        case SET_MONITORWEBLOGICHEAPS:
            return action.monitorWeblogicHeaps
        default:
            return state
    }
};

function selectedMonitorWeblogicHeap(state = null, action) {
    switch (action.type) {
        case SET_SELECTEDMONITORWEBLOGICHEAP:
            return action.selectedMonitorWeblogicHeap
        default:
            return state
    }
};

function monitorAgentDiskSpaceDiskNames(state = [], action) {
    switch (action.type) {
        case SET_MONITORAGENTDISKSPACEDISKNAMES:
            return action.monitorAgentDiskSpaceDiskNames
        default:
            return state
    }
};

function selectedMonitorAgentDiskSpaceDiskName(state = null, action) {
    switch (action.type) {
        case SET_SELECTEDMONITORAGENTDISKSPACEDISKNAME:
            return action.selectedMonitorAgentDiskSpaceDiskName
        default:
            return state
    }
};

function monitorAgentProcesss(state = [], action) {
    switch (action.type) {
        case SET_MONITORAGENTPROCESSS:
            return action.monitorAgentProcesss
        default:
            return state
    }
};

function selectedMonitorAgentProcess(state = null, action) {
    switch (action.type) {
        case SET_SELECTEDMONITORAGENTPROCESS:
            return action.selectedMonitorAgentProcess
        default:
            return state
    }
};

function monitorAgentServices(state = [], action) {
    switch (action.type) {
        case SET_MONITORAGENTSERVICES:
            return action.monitorAgentServices
        default:
            return state
    }
};

function selectedMonitorAgentService(state = null, action) {
    switch (action.type) {
        case SET_SELECTEDMONITORAGENTSERVICE:
            return action.selectedMonitorAgentService
        default:
            return state
    }
};

function monitorAgentNetIFs(state = [], action) {
    switch (action.type) {
        case SET_MONITORAGENTNETIFS:
            return action.monitorAgentNetIFs
        default:
            return state
    }
};

function selectedMonitorAgentNetIF(state = null, action) {
    switch (action.type) {
        case SET_SELECTEDMONITORAGENTNETIF:
            return action.selectedMonitorAgentNetIF
        default:
            return state
    }
};

function monitorAgentDiskIONames(state = [], action) {
    switch (action.type) {
        case SET_MONITORAGENTDISKIONAMES:
            return action.monitorAgentDiskIONames
        default:
            return state
    }
};

function selectedMonitorAgentDiskIOName(state = null, action) {
    switch (action.type) {
        case SET_SELECTEDMONITORAGENTDISKIONAME:
            return action.selectedMonitorAgentDiskIOName
        default:
            return state
    }
};

function monitorAgentDiskInodesNames(state = [], action) {
    switch (action.type) {
        case SET_MONITORAGENTDISKINODESNAMES:
            return action.monitorAgentDiskInodesNames
        default:
            return state
    }
};

function selectedMonitorAgentDiskInodesName(state = null, action) {
    switch (action.type) {
        case SET_SELECTEDMONITORAGENTDISKINODESNAME:
            return action.selectedMonitorAgentDiskInodesName
        default:
            return state
    }
};

function monitorAgentScripts(state = [], action) {
    switch (action.type) {
        case SET_MONITORAGENTSCRIPTS:
            return action.monitorAgentScripts
        default:
            return state
    }
};

function selectedMonitorAgentScript(state = null, action) {
    switch (action.type) {
        case SET_SELECTEDMONITORAGENTSCRIPT:
            return action.selectedMonitorAgentScript
        default:
            return state
    }
};

function monitorOracleTableSpace(state = [], action) {
    switch (action.type) {
        case SET_MONITORORACLETABLESPACE:
            return action.monitorOracleTableSpace
        default:
            return state
    }
};

function selectedMonitorOracleTableSpace(state = null, action) {
    switch (action.type) {
        case SET_SELECTEDMONITORORACLETABLESPACE:
            return action.selectedMonitorOracleTableSpace
        default:
            return state
    }
};

function resourcesPropertyData(state = null, action) {
    switch (action.type) {
        case SET_RESOURCES_PROPERTY_DATA:
            return action.resourcesPropertyData
        default:
            return state
    }
};

function testPropertyData(state = null, action) {
    switch (action.type) {
        case SET_TEST_PROPERTY_DATA:
            return action.testPropertyData
        default:
            return state
    }
};
function equipmentAccessoryInfos(state = [], action) {
    switch (action.type) {
    case SET_EQUIPMENT_ACCESSORYINFOS:
            return action.equipmentAccessoryInfos
        default:
            return state
    }
};
function getResourcesPropertyDataDoneFlag(state = false, action) {
    switch (action.type) {
        case SET_GETRESOURCESPROPERTYDATADONEFLAG:
            return action.getResourcesPropertyDataDoneFlag
        default:
            return state
    }
};

function resourcesPropertyEdit(state = false, action) {
    switch (action.type) {
        case SET_RESOURCES_PROPERTY_EDIT:
            return action.resourcesPropertyEdit
        default:
            return state
    }
};

function depend(state = {}, action) {
    switch (action.type) {
        case SET_DEPEND:
            return action.depend
        default:
            return state
    }
};

function alertDepend(state = {}, action) {
    switch (action.type) {
        case SET_ALERTDEPEND:
            return action.alertDepend
        default:
            return state
    }
};

function resourcesAlarmConfig(state = [], action) {
    switch (action.type) {
        case SET_RESOURCESALARMCONFIG:
            return action.resourcesAlarmConfig
        default:
            return state
    }
};

function resourcesSelectedAlarmConfig(state = {}, action) {
    switch (action.type) {
        case SET_RESOURCESSELECTEDALARMCONFIG:
            return action.resourcesSelectedAlarmConfig
        default:
            return state
    }
};

function resourceEquipmentModel(state = [{id:0, name:'other'}], action) {
    switch (action.type) {
    case SET_RESOURCE_EQUIPMENTMODEL:
            return action.resourceEquipmentModel
        default:
            return state
    }
};

function resourceModal(state = null, action) {
    switch (action.type) {
    case SET_RESOURCEMODAL:
            return action.resourceModal
        default:
            return state
    }
};

function createMonitors(state = null, action) {
    switch (action.type) {
    case SAVE_CREATEMONITORS:
            return action.createMonitors
        default:
            return state
    }
};

function resourcesData(state = null, action) {
    switch (action.type) {
    case SAVE_RESOURCEDATA:
            return action.resourcesData
        default:
            return state
    }
};

function operateMonitor(state = null, action) {
    switch (action.type) {
    case SET_OPERATEMONITOR:
            return action.operateMonitor
        default:
            return state
    }
};

function equipmentGroupId(state = null, action) {
    switch (action.type) {
    case SET_EQUIPMENTGROUPID:
            return action.equipmentGroupId
        default:
            return state
    }
};

function refreshResourceMonitors(state = [], action) {
    switch (action.type) {
    case SET_REFRESH_RESOURCE_MONITORS:
            return action.refreshResourceMonitors
        default:
            return state
    }
};

function loadingMonitorList(state = false, action) {
    switch (action.type) {
    case SET_LOADING_MONITOR_LIST:
            return action.loadingMonitorList
        default:
            return state
    }
};

function selectedClickNode(state = null, action) {
    switch (action.type) {
    case SET_SELECTED_CLICK_NODE:
            return action.selectedClickNode
        default:
            return state
    }
};

function resourceViewActiveTab(state = '1', action) {
    switch (action.type) {
    case SET_RESOURCE_VIEW_ACTIVE_TAB:
            return action.resourceViewActiveTab
        default:
            return state
    }
};

function monitorStatusReportData(state = {}, action) {
    switch (action.type) {
    case SET_MONITOR_STATUS_REPORT_DATA:
            return action.monitorStatusReportData
        default:
            return state
    }
};

function batchMonitorStatusReportData(state = [], action) {
    switch (action.type) {
    case SET_BATCH_MONITOR_STATUS_REPORT_DATA:
            return action.batchMonitorStatusReportData
        default:
            return state
    }
};

function safeGroupList(state = [], action) {
    switch (action.type) {
    case SET_SAFE_GROUP_LIST:
            return action.safeGroupList
        default:
            return state
    }
};

function taskSchedulerList(state = [], action) {
    switch (action.type) {
    case SET_TASK_SCHEDULER_LIST:
            return action.taskSchedulerList
        default:
            return state
    }
};

function networkNodeType(state = [], action) {
    switch (action.type) {
    case SET_NETWORK_NODE_TYPE:
            return action.networkNodeType
        default:
            return state
    }
};

function equipmentNodeType(state = {type: ''}, action) {
    switch (action.type) {
    case SET_EQUIPMENT_NODE_TYPE:
            return action.equipmentNodeType
        default:
            return state
    }
};

function networkRelations(state = [], action) {
    switch (action.type) {
    case SET_NETWORK_RELATIONS:
            return action.networkRelations
        default:
            return state
    }
};

function selectedLevel(state = '', action) {
    switch (action.type) {
    case SET_SELECTEDLEVEL:
            return action.selectedLevel
        default:
            return state
    }
};

function draggedNode(state = null, action) {
    switch (action.type) {
    case SET_DRAGGEDNODE:
            return action.draggedNode
        default:
            return state
    }
};

function selectedMonitorFrom3D(state = null, action) {
    switch (action.type) {
    case SET_SELECTED_MONITOR_FROM_3D:
            return action.selectedMonitorFrom3D
        default:
            return state
    }
};

const equipmentReducer = combineReducers({
    errorAlarm,
    goodAlarm,
    warningAlarm,
    logGood,
    logError,
    logDanger,
    logBan,
    functionValue,
    monitors,
    /*curFuncValName,
    curFuncValAvg,
    curFuncValMax,
    curFuncValMin,
    curFuncValNew,*/
    funcValue,
    curTowHourName,
    curTowHourValue,
    twoHoursReport,
    monitorTableData,
    monitorsStatus,
    monitorFilterStatus,
    groupId,
    equipments,
    subGroups,
    status,
    groupInfoFilterStatus,
    monitorTableSelectFirstFlag,
    selectedMonitorName,
    resourceSetTree,
    equipmentIdNtz,
    alarmRulesArray,
    equipmentId,
    bClickTreeNode,
    onTreeNodeClick,
    bClickDesViewMonitorTableRow,
    getMonitorDataFilter,
    treeIds, oldTree, assetIdNtz,
    createResourceViewId,
    selectedResource,
    backupResource,
    createMonitorViewId,
    selectedMonitor,
    createResourcesTableData,
    createMonitorsTableData,
    selectedNode, selectedNodeId, resourceTypes,
    backupTreeNode,
    commonMonitors,
    monitorAlarmConditionNameData,
    monitorErrorAlarmText,
    monitorWarningAlarmText,
    monitorGoodAlarmText,
    monitorErrorConditionsData,
    monitorSettingErrorConditionsData,
    monitorWarningConditionsData,
    monitorSettingWarningConditionsData,
    monitorGoodConditionsData,
    monitorSettingGoodConditionsData,
    deleteMonitorAlarmConditionsData,
    equipmentServerAddress,
    equipmentModel,
    navigateFromCreateMonitorViewFlag,
    monitorDisks,
    monitorHasDisks,
    selectedMonitorDisk,
    monitorDiskInodes,
    monitorHasDiskInodes,
    selectedMonitorDiskInodes,
    monitorDiskIONames,
    monitorHasDiskIONames,
    selectedMonitorDiskIOName,
    networks,
    hasNetworks,
    selectedNetwork,
    monitorNetworks,
    monitorHasNetworks,
    selectedMonitorNetwork,
    monitorProcesses,
    monitorHasProcesses,
    selectedMonitorProcess,
    monitorServices,
    monitorHasServices,
    selectedMonitorService,
    monitorNTEventLogs,
    selectedMonitorNTEventLog,
    monitorScripts,
    selectedMonitorScript,
    VMwareNames,
    hasVMwareNames,
    selectedVMwareNames,
    getMonitorsPropertyDataDoneFlag,
    getAlarmConditionDataDoneFlag,
    getMySqlMonitorCounterDataDoneFlag,
    getSQLServerMonitorCounterDataDoneFlag,
    isShowTree,
    getOldTree,
    monitorsPropertyData,
    monitorsPropertyEdit,
    mySqlCounterData,
    mySqlMonitorsPropertyCounterData,
    mySqlCurrentCounterData,
    OracleCounterData,
    OracleMonitorsPropertyCounterData,
    OracleCurrentCounterData,
    monitorScriptsEntryAlias,
    getMonitorsEntryAliasDataDoneFlag,
    monitorSnmpMIBFile,
    monitorSnmpMIBCounter,
    selectedMonitorSnmpMIBCounter,
    selectedMonitorMongoQuery,
    monitorIPMISensorCounters,
    selectedMonitorIPMISensorCounter,
    monitorStorageDisks,
    selectedMonitorStorageDisk,
    monitorSQLServerCounters,
    sqlServerMonitorsPropertyCounterData,
    selectedMonitorSQLServerCounter,
    monitorStorageProcessors,
    selectedMonitorStorageProcessor,
    monitorFibreChannelStatusNodes,
    selectedMonitorFibreChannelStatusNode,
    monitorStorageVolumeFiles,
    selectedMonitorStorageVolumeFile,
    monitorRoomEnvironmentObjects,
    selectedMonitorRoomEnvironmentObject,
    monitorWeblogicExecuteQueues,
    selectedMonitorWeblogicExecuteQueue,
    monitorWeblogicWebApps,
    selectedMonitorWeblogicWebApp,
    monitorWeblogicConnPools,
    selectedMonitorWeblogicConnPool,
    monitorVMwareHostNetworks,
    selectedMonitorVMwareHostNetwork,
    monitorVMwarePerformances,
    selectedMonitorVMwarePerformance,
    monitorWeblogicClusters,
    selectedMonitorWeblogicCluster,
    monitorWeblogicServers,
    selectedMonitorWeblogicServer,
    monitorWeblogicHeaps,
    selectedMonitorWeblogicHeap,
    monitorAgentDiskSpaceDiskNames,
    selectedMonitorAgentDiskSpaceDiskName,
    monitorAgentProcesss,
    selectedMonitorAgentProcess,
    monitorAgentServices,
    selectedMonitorAgentService,
    monitorAgentNetIFs,
    selectedMonitorAgentNetIF,
    monitorAgentDiskIONames,
    selectedMonitorAgentDiskIOName,
    monitorAgentDiskInodesNames,
    selectedMonitorAgentDiskInodesName,
    monitorAgentScripts,
    selectedMonitorAgentScript,
    monitorOracleTableSpace,
    selectedMonitorOracleTableSpace,
    resourcesPropertyData,
    getResourcesPropertyDataDoneFlag,
    resourcesPropertyEdit,
    equipmentMonitorUrl,
    depend,
    alertDepend,
    resourcesAlarmConfig,
    resourcesSelectedAlarmConfig,
    resourceEquipmentModel,
    resourceModal,
    testPropertyData,
    equipmentAccessoryInfos,
    createMonitors,
    resourcesData,
    operateMonitor,
    equipmentGroupId,
    equipmentWindowStore,
    refreshResourceMonitors,
    loadingMonitorList,
    selectedClickNode,
    resourceViewActiveTab,
    monitorStatusReportData,
    batchMonitorStatusReportData,
    safeGroupList,
    taskSchedulerList,
    networkNodeType,
    equipmentNodeType,
    networkRelations,
    selectedLevel,
    monitorDetailViewActiveTab,
    monitorDetailViewTimeRange,
    draggedNode,
    selectedMonitorFrom3D,
    beAddMonitorsNode,
    equipmentInfoMaintenanceData
})

export default equipmentReducer
